module.exports = __webpack_public_path__ + "img/logo2.315645ff.png";